import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';

const deletePage = (pageId: number) => api.delete(`/pages/${pageId}`);

export const useDeletePageMutation = () => {
  return useMutation({
    mutationKey: ['deletePage'],
    mutationFn: deletePage,
  });
};
